module.exports = __webpack_public_path__ + "img/book.12fabebe.svg";